<template>
  <div class="book-generator">
    <h1>AI Book Generator</h1>
    <v-form ref="form">
      <v-text-field v-model="bookLength" label="Book Length" required></v-text-field>
      <v-text-field v-model="gptRole" label="Role of GPT-3.5" required></v-text-field>
      <v-text-field v-model="genre" label="Genre" required></v-text-field>
      <v-text-field v-model="keywords" label="Keywords" hint="Use commas to separate keywords" required></v-text-field>
      <v-checkbox v-model="autoGenerateChapters" label="Auto Generate Chapters"></v-checkbox>
      
      <v-btn color="primary" @click.prevent="generateConcept">Generate Concept</v-btn>
      <v-btn color="primary" @click.prevent="generateTableOfContents">Generate Table of Contents</v-btn>
      <v-btn color="primary" @click.prevent="generateChapters">Generate Chapters</v-btn>
      <v-btn color="primary" @click.prevent="exportToTxtMethod">Export to TXT</v-btn>
    </v-form>

    <v-textarea v-model="concept" label="Book Concept" readonly></v-textarea>
    <v-textarea v-model="tableOfContents" label="Table of Contents" readonly></v-textarea>
    <div v-html="chaptersHtml" class="chapters"></div>
  </div>
</template>

<script>
import { generateConcept, generateTableOfContents, generateChapters, exportToTxt } from './bookscript.js';

export default {
  data() {
    return {   
      bookLength: '',
      gptRole: '',
      genre: '',
      keywords: '',
      autoGenerateChapters: false,
      concept: '',
      tableOfContents: '',
      chaptersHtml: ''
    };
  },
  methods: {
    async generateConcept() {
      const concept = await generateConcept({
        gptRole: this.gptRole,
        bookLength: this.bookLength,
        genre: this.genre,
        keywords: this.keywords.split(',')
      });
      this.concept = concept;
    },
    async generateTableOfContents() {
      const contents = await generateTableOfContents({
        gptRole: this.gptRole,
        genre: this.genre,
        keywords: this.keywords.split(','),
        concept: this.concept
      });
      this.tableOfContents = contents;
    },
    async generateChapters() {
      const chapters = await generateChapters({
        gptRole: this.gptRole,
        genre: this.genre,
        keywords: this.keywords.split(','),
        tableOfContents: this.tableOfContents,
        autoGen: this.autoGenerateChapters
      });
      this.chaptersHtml = chapters.map(chapter => `<h2>${chapter.title}</h2><p>${chapter.content.replace(/\n/g, '<br/>\n')}</p>`).join('');
    },
    exportToTxtMethod() {
      exportToTxt(this.chaptersHtml);
    }
  }
};
</script>

<style scoped>
.book-generator {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}
.book-generator h1 {
  text-align: center;
}
.chapters h2 {
  margin-top: 20px;
  font-size: 16px;
}
.chapters div {
  margin-top: 20px;
  font-size: 16px;
}
textarea {
  margin-bottom: 20px;
}
</style>
